import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';

const steps = [
  {
    number: '01',
    icon: <UploadFileRoundedIcon sx={{ fontSize: 36 }} />,
    title: 'Upload your schema',
    description:
      'Import a CSV, JSON, or Avro schema — or connect directly to your database. Cynthia reads your field names, data types, and relationships without ever touching your real records.',
  },
  {
    number: '02',
    icon: <TuneRoundedIcon sx={{ fontSize: 36 }} />,
    title: 'Configure your population',
    description:
      'Set volume, demographic distributions, and domain-specific parameters. For healthcare, dial in diagnosis codes, age ranges, and comorbidity patterns. For finance, set transaction frequency and amount distributions.',
  },
  {
    number: '03',
    icon: <CloudDownloadRoundedIcon sx={{ fontSize: 36 }} />,
    title: 'Export to your pipeline',
    description:
      'Download as CSV, JSON, or FHIR R4. Pro and Enterprise plans support direct export to S3, your data warehouse, or an existing FHIR server — ready to drop into your CI pipeline or ML training run.',
  },
];

export default function HowItWorks() {
  return (
    <Container
      id="how-it-works"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography component="h2" variant="h4" color="text.primary">
          How it works
        </Typography>
        <Typography variant="body1" color="text.secondary">
          From schema to synthetic dataset in three steps — no PHI required at any stage.
        </Typography>
      </Box>
      <Grid container spacing={4} justifyContent="center">
        {steps.map((step) => (
          <Grid item xs={12} md={4} key={step.number}>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 800,
                    color: 'primary.main',
                    opacity: 0.25,
                    lineHeight: 1,
                    minWidth: 48,
                  }}
                >
                  {step.number}
                </Typography>
                <Box sx={{ color: 'primary.main' }}>{step.icon}</Box>
              </Box>
              <Typography variant="h6" color="text.primary" fontWeight={600}>
                {step.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {step.description}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
